import moment from 'moment';
import { NumericTickProvider, type NumberRange } from 'scichart';

/**
 * Date axis ticks on the first of the month. The gap between ticks grows with
 * the range shown, from every month up to every two years.
 */
export class MonthlyTickProvider extends NumericTickProvider {
  /**
   * The first of each month in the range, at the gap that fits the range.
   *
   * @param {number} _minorDelta - Unused; SciChart passes its own minor gap.
   * @param {number} _majorDelta - Unused; SciChart passes its own major gap.
   * @param {NumberRange} visibleRange - The dates shown, in milliseconds.
   * @return {number[]} The tick dates, in milliseconds.
   */
  override getMajorTicks(
    _minorDelta: number,
    _majorDelta: number,
    visibleRange: NumberRange
  ): number[] {
    const startMonth = moment.utc(visibleRange.min).startOf('month');
    const endMonth = moment.utc(visibleRange.max).endOf('month');
    const totalMonths = endMonth.diff(startMonth, 'months');

    let interval = 1;
    if (totalMonths > 120) interval = 24;
    else if (totalMonths > 60) interval = 12;
    else if (totalMonths > 36) interval = 6;
    else if (totalMonths > 18) interval = 3;
    else if (totalMonths > 8) interval = 2;

    const ticks: number[] = [];
    const current = startMonth.clone();
    while (current.isSameOrBefore(endMonth)) {
      ticks.push(current.valueOf());
      current.add(interval, 'months');
    }
    return ticks;
  }

  /**
   * No minor ticks.
   *
   * @return {number[]} An empty list.
   */
  override getMinorTicks(): number[] {
    return [];
  }
}
